import { Spin, message } from "antd";
import "./App.css";
import "antd/dist/antd.min.css";
import { lazy, Suspense, useRef } from "react";
import { getApolloClient } from "lib/init-apollo";
import { ApolloProvider } from "@apollo/client";
import PopupContainerProvider from "providers/popup-container-provider";

interface AppProps {
  config?: any;
}

const UserTasksList = lazy(() => import("./containers/user-tasks"));

function App({ config }: AppProps) {
  const { widgetSettings } = config;
  const { token, endPoint } = widgetSettings;
  const client = getApolloClient(token, endPoint);
  const messageContainerRef = useRef(null);
  message.config({
    getContainer() {
      return messageContainerRef.current;
    },
  });

  let Component = null;
  let componentProps = {};
  switch (config.widget) {
    case "USERTASKS":
      Component = UserTasksList;
      componentProps = { componentName: "User Tasks", ...config };
      break;
  }
  return (
    <ApolloProvider client={client}>
      <PopupContainerProvider>
        <Suspense fallback={<Spin />}>
          {config && <Component {...componentProps} />}
          <div ref={messageContainerRef}></div>
        </Suspense>
      </PopupContainerProvider>
    </ApolloProvider>
  );
}

export default App;
